export const CitekMark = ({ size = 40, className = "" }) => (
  <img
    src="/citek-icon.png"
    alt="Logo CITEK"
    width={size}
    height={size}
    className={`rounded-lg border border-black/10 bg-white object-contain shadow-sm ${className}`}
    data-testid="citek-logo-mark"
  />
);

export default function Logo({ compact = false }) {
  return (
    <span className="flex items-center gap-3 select-none">
      <CitekMark size={compact ? 62 : 84} />
      <span className="flex flex-col leading-none">
        <span className="font-display font-extrabold tracking-tight text-zinc-900 text-2xl uppercase">
          CITEK<span className="text-citek-green">.</span>
        </span>
        <span className="font-tech text-[11px] uppercase tracking-[0.28em] text-zinc-500 mt-1">
          Entreprise S.A.S
        </span>
      </span>
    </span>
  );
}
